import { createSelector } from 'reselect'

const selectData = state => state.screens.SubProjects.data

export default createSelector(
  selectData,
  (data) => data,
)
